import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// @mui/material components
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

// core components
import HeaderContainer from "components/List/components/HeaderContainer";

// style
import {greyishBlue700} from "assets/jss/main";

// shared grid layout
import {RETAILER_LIST_GRID} from "./retailerListGrid";

const SortArrow = ({direction, active}) => (
    <svg
        width="10"
        height="9"
        viewBox="0 0 10 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
            marginLeft: '4px',
            opacity: active ? 1 : 0.3,
            transform: direction === 'asc' ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s ease, opacity 0.2s ease',
        }}
    >
        <path
            d="M9.63508 2.24421L6.21985 8.22086C5.644 9.22858 4.19096 9.22858 3.61512 8.22086L0.199887 2.24421C-0.371533 1.24422 0.350517 2.9881e-08 1.50225 1.30569e-07L8.33271 7.27707e-07C9.48445 8.28394e-07 10.2065 1.24422 9.63508 2.24421Z"
            fill={greyishBlue700}
        />
    </svg>
);

function SortableColumn({label, sortKey, activeSortKey, sortDirection, onSort, sx = {}}) {
    const isActive = activeSortKey === sortKey;

    return (
        <Box
            sx={{...sx, cursor: 'pointer', userSelect: 'none', display: 'flex', alignItems: 'center'}}
            onClick={() => onSort(sortKey)}
        >
            {label}
            <SortArrow direction={isActive ? sortDirection : 'desc'} active={isActive} />
        </Box>
    );
}

RetailerListHeader.propTypes = {
    sortKey: PropTypes.string,
    sortDirection: PropTypes.oneOf(['asc', 'desc']),
    onSort: PropTypes.func.isRequired,
};

function RetailerListHeader({sortKey, sortDirection, onSort}) {
    return (
        <HeaderContainer>
            <Box sx={RETAILER_LIST_GRID}>
                <SortableColumn
                    label={<FormattedMessage id={"retailer.list.table.header.name"} />}
                    sortKey="name"
                    activeSortKey={sortKey}
                    sortDirection={sortDirection}
                    onSort={onSort}
                />
                <SortableColumn
                    label={<FormattedMessage id="retailer.list.table.header.validated" />}
                    sortKey="validProductCount"
                    activeSortKey={sortKey}
                    sortDirection={sortDirection}
                    onSort={onSort}
                />
                <SortableColumn
                    label={<FormattedMessage id={"retailer.list.table.header.warning.mappings"} />}
                    sortKey="unmappedProductCount"
                    activeSortKey={sortKey}
                    sortDirection={sortDirection}
                    onSort={onSort}
                    sx={{justifyContent: 'center'}}
                />
                <SortableColumn
                    label={<FormattedMessage id="retailer.list.table.header.toEnrich" />}
                    sortKey="incompleteProductCount"
                    activeSortKey={sortKey}
                    sortDirection={sortDirection}
                    onSort={onSort}
                />
                <Box sx={{textAlign: 'center'}}>
                    <FormattedMessage id="retailer.list.table.header.import" />
                </Box>
                <Box sx={{textAlign: 'center'}}>
                    <FormattedMessage id={"retailer.list.table.header.warning.product.push"} />
                </Box>
                <Box sx={{textAlign: 'center'}}>
                    <FormattedMessage id={"list.header.actions"} />
                </Box>
            </Box>
        </HeaderContainer>
    );
}

export default RetailerListHeader;
